<!--
 * @Author: wangpeng wangpeng@bailongma-inc.com
 * @Date: 2024-10-10 15:53:24
 * @LastEditors: wangpeng wangpeng@bailongma-inc.com
 * @LastEditTime: 2024-10-23 20:02:33
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div v-loading="loading">
    <div class="batch_tips">填写说明:</div>
    <div class="batch_tips">
      1、车牌号必须完整输入并回车确定，每个车牌号一行，如：京P12345，京P23456；
    </div>
    <div class="batch_tips">
      2、车牌号需要在后台中存在且未退出运营，如果输入了不存在的车牌号，确定后系统会自动过滤
    </div>
    <div class="batch_input">
      <el-input
      clearable
      type="textarea"
      :rows="20"
      placeholder="请输入内容"
      v-model="batchTextarea"
      @input="handleTextAreaInput"
    >
    </el-input>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { Message } from '@qs/ui'
import { getDeptCarList } from '@/api/domain/organize'

const batchTextarea = ref('')
const loading = ref(false)

const toUpperCaseExcludeNumbers = (str) =>
  str.replace(/\s*/g, '').replace(/[a-z]/g, (match) => match.toUpperCase())


const handleTextAreaInput = () => {
  batchTextarea.value = batchTextarea.value
    .replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g, '')
    .replace(/^[:\n\r]+$/g, '')
}

const validate = () => {
  return new Promise((resolve) => {
    if (batchTextarea.value.length === 0) {
      Message.error('请填写车牌号或vin码')
      resolve(null)
    }
    const list = []
    batchTextarea.value
      .split('\n')
      .forEach((element) => {
        const str = toUpperCaseExcludeNumbers(element)
        if (str && !list.includes(str)) {
          list.push(str)
        }
      })

    if (list.length > 4000) {
      Message.warning('最多只能输入4000条数据')
      resolve(null)
    }

    if (list.length === 0) {
      resolve(null)
    }

    loading.value = false
    getDeptCarList({
      pageNum: 1,
      pageSize: 4000,
      plateNoOrVinList: list,
    })
      .then(({ code, data }) => {
        if (code === 1 && data?.items.length > 0) {
          resolve(data?.items.map((item) => ({
            ...item,
            plateNoOrVin: item.plateNo || item.vin,
          })))
        } else {
          Message.error('请输入正确的车牌号或vin码')
          resolve(null)
        }
      })
      .finally(() => {
        loading.value = false
      })
  })
}

defineExpose({
  validate,
})
</script>

<style lang="scss" scoped>
.batch_tips {
  font-size: 14px;
  margin-bottom: 10px;
  color: #333;
}
.batch_input{
  width: 100%;
}
</style>
